import HubstaffErrorReporter from './Sentry';
import { SENTRY_ENABLED } from '~/server_env';

let hubstaffErrorReporter;

export function initErrorHandling() {
  if (SENTRY_ENABLED) {
    hubstaffErrorReporter = new HubstaffErrorReporter();
    window.__hubstaffErrorReporter = hubstaffErrorReporter;
  }
}

export function reportError(error, context, severity) {
  if (SENTRY_ENABLED && hubstaffErrorReporter) {
    hubstaffErrorReporter.reportError(error, context, severity);
  }
}
